import React from 'react'
import { Icon } from '../icon'
import styled, { useTheme } from 'styled-components'

export interface ContactProps {
  avatar: string
  name: string
  title: string
  chat: string
  onCard: () => void
}

const Container = styled.div`
  height: 4.5rem;
  width: 100%;
  padding: 0 20px;
  
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`
const Avatar = styled.img`
  height: 2.75rem;
  width: 2.75rem;
  border-radius: 50%;
  margin-right: 0.25rem;
`
const Info = styled.div`
  margin-right: auto;
  .name {
    font-weight: bold;
  }
  .title {
    font-size: 0.75rem;
    color: ${props => props.theme.colors.theme};
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  & > * + * {
    padding-left: 1rem;
    border-left: 1px solid ${props => props.theme.colors.line};
    margin-left: 1rem;
  }
`
interface ActionProps {
  onClick: () => void
  iconCode: string
  text: string
}
const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  & > * + * {
    margin-top: 0.25rem;
  }
  cursor: pointer;
`
const IconContainer = styled.div`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.theme};
  
  display: flex;
  justify-content: center;
  align-items: center;
`
const TextContainer = styled.div`
  font-size: 0.75rem;
`
const Action: React.VFC<ActionProps> = ({ iconCode, text, onClick }) => {
  const { colors } = useTheme()
  return (
    <ActionContainer onClick={onClick}>
      <IconContainer>
        <Icon code={iconCode} size={16} color={colors.white} />
      </IconContainer>
      <TextContainer>
        {text}
      </TextContainer>
    </ActionContainer>
  )
}

export const Contact: React.VFC<ContactProps> = ({ avatar, name, title, chat, onCard }) => {
  return (
    <Container>
      <Avatar src={avatar} />
      <Info>
        <div className="name">{name}</div>
        <div className="title">{title}</div>
      </Info>
      <Actions>
        <Action onClick={onCard} iconCode="mingpian2" text="查看名片" />
        <Action onClick={() => window.open(chat, '_blank')} iconCode="paichu1" text="在线沟通" />
      </Actions>
    </Container>
  )
}
